import * as React from 'react'
import { Loader2 } from 'lucide-react'
import { Button } from '@axilon-apps/libs-ui-shadcn'

type ButtonProps = React.ComponentProps<typeof Button>

interface LoadingButtonProps extends Omit<ButtonProps, 'disabled'> {
  loading?: boolean
  disabled?: boolean
  startDecorator?: React.ReactNode
  endDecorator?: React.ReactNode
  children: React.ReactNode
}

const LoadingButton = ({
  loading = false,
  disabled = false,
  startDecorator,
  endDecorator,
  children,
  ...buttonProps
}: LoadingButtonProps) => {
  return (
    <Button {...buttonProps} disabled={disabled || loading}>
      {startDecorator}
      {children}
      {loading ? <Loader2 className="animate-spin" /> : endDecorator}
    </Button>
  )
}

export default LoadingButton
